import { useQuery } from 'react-query';

export default () => {
  const { data, isLoading, isSuccess } = useQuery(['GET', `/apis/v2/patient/payment_method`, {}], {
    retry: false,
    refetchOnMount: false,
  });

  return {
    data,
    isLoading,
    isSuccess,
  };
};
